import React, { useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import classes from "../Styles/about.module.css";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FolderIcon from "@mui/icons-material/Folder";
import BallotIcon from "@mui/icons-material/Ballot";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const ProfessionalInfo = () => {
  const [isInterestOpen, setIsInterest] = useState(true);
  const [isPersonalOpen, setIsPersonal] = useState(true);
  const [isProfOpen, setIsProf] = useState(false);
  const [isEdOpen, setIsEd] = useState(false);
  const [isContactOpen, setIsContact] = useState(true);
  const [isSkillOpen, setIsSkill] = useState(false);
  const [isExp, setIsExp] = useState(false);
  const [isRefer, setIsRefer] = useState(false);
  const [isHobbies, setIsHob] = useState(false);
  return (
    <>
      <Grid item md={2.4} xs={12} className={classes.grid_item_inner}>
        <Box
          onClick={() => setIsPersonal(!isPersonalOpen)}
          sx={{
            display: { xs: "flex", md: "none" },
            color: "white",
            width: "100%",
            borderBottom: "0.25px solid #1E2D3D",
            backgroundColor: { xs: "#1E2D3D", md: "transparent" },
            pt: 2,
            pb: 1,
            cursor: "pointer",
          }}
        >
          {isPersonalOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <Typography className={classes.about_text}>
            personal-information
          </Typography>
        </Box>
        <Box sx={{ display: isPersonalOpen ? "block" : "none" }}>
          <Box
            onClick={() => setIsInterest(!isInterestOpen)}
            sx={{
              display: { xs: "flex", md: "none" },
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isInterestOpen ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}

            <FolderIcon
              sx={{ color: "#43D9AD", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              interests
            </Typography>
          </Box>
          <Box sx={{ display: isInterestOpen ? "block" : "none" }}>
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                web development
              </Typography>
            </Box>
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                web 3
              </Typography>
            </Box>
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                fun
              </Typography>
            </Box>
          </Box>

          <Box
            onClick={() => setIsEd(!isEdOpen)}
            sx={{
              display: { xs: "flex", md: "none" },
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isEdOpen ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}
            <FolderIcon
              sx={{ color: "#3A49A4", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              education
            </Typography>
          </Box>
          <Box sx={{ display: isEdOpen ? "block" : "none" }}>
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                University of Ilorin <br /> Mechanical Engineering
              </Typography>
            </Box>
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                Tech4dev <br /> Computer science (diploma)
              </Typography>
            </Box>
            {/* <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                starfield-early-years
              </Typography>
            </Box> */}
          </Box>
        </Box>

        {/* prof */}
        <Box
          onClick={() => setIsProf(!isProfOpen)}
          sx={{
            display: "flex",
            color: "white",
            width: "100%",
            borderBottom: "0.25px solid #1E2D3D",
            backgroundColor: { md: "transparent", xs: "#1E2D3D" },
            mt: { xs: 0.5, md: 0 },
            mb: { xs: 0.5, md: 0 },
            pt: 2,
            pb: 1,
            cursor: "pointer",
          }}
        >
          {isProfOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <Typography className={classes.about_text}>
            professional-information
          </Typography>
        </Box>

        <Box sx={{ display: isProfOpen ? "block" : "none" }}>
          <Box
            onClick={() => setIsSkill(!isSkillOpen)}
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isSkillOpen ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}

            <FolderIcon
              sx={{ color: "#43D9AD", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              skills
            </Typography>
          </Box>
          <Box sx={{ display: isSkillOpen ? "block" : "none" }}>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                html
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                css
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                js
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                react-js
              </Typography>
            </Box>{" "}
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                react-query
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                typescript
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                bootstrap
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                mui
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                python-django
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                graphql
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                node (express)
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                github / bitbucket
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                jira / trello
              </Typography>
            </Box>
          </Box>

          <Box
            onClick={() => setIsExp(!isExp)}
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isExp ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}
            <FolderIcon
              sx={{ color: "#3A49A4", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              experience
            </Typography>
          </Box>
          <Box sx={{ display: isExp ? "block" : "none" }}>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                tech11 (GmbH) (nov 2021 - current)
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                prunedge (jan 2020 - current)
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                facility-bills (april 2019 -may 2020) <br />
                (current as contractor)
              </Typography>
            </Box>
          </Box>

          <Box
            onClick={() => setIsRefer(!isRefer)}
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
              cursor: "pointer",
            }}
          >
            {isRefer ? (
              <ArrowForwardIosIcon
                sx={{ fontSize: "15px", pt: 0.3, transform: "rotate(90deg)" }}
              />
            ) : (
              <ArrowForwardIosIcon sx={{ fontSize: "15px", pt: 0.3 }} />
            )}
            <FolderIcon
              sx={{ color: "#E99287", pl: 0.5, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder}>
              reference
            </Typography>
          </Box>
          <Box sx={{ display: isRefer ? "block" : "none" }}>
            <Box
              sx={{
                display: "flex",
                color: "#607B96",
                width: "100%",
                pl: 0.4,
                pt: 2,
                pb: 1,
              }}
            >
              <BallotIcon
                sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
              />
              <Typography className={classes.about_text_folder_under}>
                ridwan sodiq <br />
                snr software engr (builtai.co) <br />
                ridwansodiq@builtai.co <br />
                +2348139569356
              </Typography>
            </Box>
          </Box>
        </Box>

        {/*end prof */}

        <Box
          onClick={() => setIsHob(!isHobbies)}
          sx={{
            display: { xs: "flex", md: "none" },
            color: "white",
            width: "100%",
            borderBottom: "0.25px solid #1E2D3D",
            backgroundColor: "#1E2D3D",
            mt: 0.5,
            mb: 0.5,
            pt: 2,
            pb: 1,
            cursor: "pointer",
          }}
        >
          {isHobbies ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <Typography className={classes.about_text}>hobbies</Typography>
        </Box>
        <Box sx={{ display: isHobbies ? "block" : "none" }}>
          <Box
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
            }}
          >
            <BallotIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              Learning
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
            }}
          >
            <BallotIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              Reading
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
            }}
          >
            <BallotIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              Coding
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              color: "#607B96",
              width: "100%",
              pl: 0.4,
              pt: 2,
              pb: 1,
            }}
          >
            <BallotIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              Tutoring
            </Typography>
          </Box>
        </Box>
        <Box
          onClick={() => setIsContact(!isContactOpen)}
          sx={{
            display: "flex",
            color: "white",
            width: "100%",
            borderTop: "0.25px solid #1E2D3D",
            borderBottom: "0.25px solid #1E2D3D",
            backgroundColor: { xs: "#1E2D3D", md: "transparent" },
            pt: 2,
            pb: 1,
            cursor: "pointer",
          }}
        >
          {isContactOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <Typography className={classes.about_text}>contacts</Typography>
        </Box>
        <Box sx={{ display: isContactOpen ? "block" : "none" }}>
          <Box
            sx={{
              display: "flex",
              color: "white",
              width: "100%",

              pt: 2,
              pb: 1,
            }}
          >
            <EmailIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography
              className={classes.about_text_folder_under}
              sx={{ wordBreak: "break-word" }}
            >
              iadebiyi01@gmail.com
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              color: "white",
              width: "100%",

              pt: 2,
              pb: 1,
            }}
          >
            <PhoneIcon
              sx={{ color: "#81A1C1", pl: 2.2, pr: 1, fontSize: "20px" }}
            />
            <Typography className={classes.about_text_folder_under}>
              +2348139569356
            </Typography>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default ProfessionalInfo;
